/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualLeasingContractDto } from '../../models/backend-actual-leasing-contract-dto';
import { BackendPatchedActualLeasingContractRequestDto } from '../../models/backend-patched-actual-leasing-contract-request-dto';

export interface MonitoringActualsLeasingsPartialUpdate$Params {
  id: number;
  body?: BackendPatchedActualLeasingContractRequestDto;
}

export function monitoringActualsLeasingsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsLeasingsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualLeasingContractDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsLeasingsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualLeasingContractDto>;
    }),
  );
}

monitoringActualsLeasingsPartialUpdate.PATH = '/api/monitoring/actuals/leasings/{id}/';
